import React, { useRef } from "react";

export default function Announcement({
  title,
  description,
}: {
  title: string;
  description: string;
}) {
  const desc_ref = useRef(null);

  const parseDescription = (description: string) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(description, "text/html");

    // Only allow safe elements like <b>, <i>, <strong>, <em>, <u>, <a>, etc.
    const allowedTags = ["b", "i", "strong", "em", "u", "a"];

    const processNode = (node: ChildNode): React.ReactNode => {
      if (node.nodeType === Node.TEXT_NODE) {
        return node.textContent;
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        const element = node as HTMLElement;
        if (!allowedTags.includes(element.tagName.toLowerCase())) {
          return element.innerText;
        }

        const props: any = {};

        if (element.tagName.toLowerCase() === "a") {
          props.href = element.getAttribute("href") || "#";
          props.target = "_blank";
          props.rel = "noopener noreferrer";
          props.className = "link"; // Add "link" class
          props.style = { paddingLeft: "0" }; // Add inline style
        }

        return React.createElement(
          element.tagName.toLowerCase(),
          props,
          ...Array.from(element.childNodes).map(processNode)
        );
      }

      return null;
    };

    return Array.from(doc.body.childNodes).map(processNode);
  };

  return (
    <div className="ag-courses_item">
      <div className="ag-courses-item_link">
        <div className="ag-courses-item_bg"></div>

        <h2 className="ag-courses-item_title">{title}</h2>
        <p ref={desc_ref} className="ag-courses-item_title" style={{ textShadow: "none" }}>
          {parseDescription(description)}
        </p>
      </div>
    </div>
  );
}
